import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from 'react';
import { faArrowUpFromBracket } from '@fortawesome/pro-light-svg-icons/faArrowUpFromBracket';
import { useTranslation } from 'react-i18next';
import { Icon } from '../icon';
export function Input({ onSelectFile }) {
    const { t } = useTranslation();
    const inputId = useId();
    return (_jsxs("label", { htmlFor: inputId, className: "flex cursor-pointer items-center justify-center gap-1 rounded-medium border-radius border-small border-neutral-500 px-2 py-1 text-extrasmall hover:bg-neutral-200 active:bg-neutral-300", children: [_jsx(Icon, { "aria-hidden": true, icon: faArrowUpFromBracket, className: "mr-1 text-neutral-700" }), t('upload_file.add_image'), _jsx("input", { type: "file", id: inputId, className: "hidden", onChange: onSelectFile, "data-testid": "input-file", accept: ".jpg, .jpeg, .png" })] }));
}
